import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectLoadingUser = createFeatureSelector<boolean>('loadingUser');

export const selectLoadingUserState = createSelector(
    selectLoadingUser,
    (state: boolean) => state,
);
